/**
 * @generated SignedSource<<f43566eb6285cd6f11a8e08e8d33a3be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView$data = {
  readonly dateTime: AGG$DateTime | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView";
};
export type dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView$key = {
  readonly " $data"?: dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "dateTime_issueFieldDateTimeReadviewFull_DateTimeReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "dateTime"
    }
  ],
  "type": "JiraDateTimePickerField"
};

(node as any).hash = "60be07d95cc7946b937010e24a94ffe0";

export default node;
